module.exports = __webpack_public_path__ + "static/media/Arctic_Import_2026_PDF.daa014fc.pdf";